export const educationalDegrees = {
  BACHELOR: "Licenciatura",
  ENGINEERING: "Ingeniería",
  MASTER: "Maestría",
  DOCTOR: "Doctorado"
};
